import React from 'react'
import { Tab } from 'semantic-ui-react'
import AnggaranRealisasiSKPD from './AnggaranRealisasiSKPD'
import AnggaranRealisasiOPD from './AnggaranRealisasiOPD'
import AnggaranRealisasiRekening from './AnggaranRealisasiRekening';

const panes = [

   { 
      menuItem: 'Target dan Realisasi SKPD', 
      render: () => <Tab.Pane attached={false}><AnggaranRealisasiSKPD /></Tab.Pane> 
   },
   { 
      menuItem: 'Target dan Realisasi OPD', 
      render: () => <Tab.Pane attached={false}><AnggaranRealisasiOPD /></Tab.Pane> 
   },
   // { 
   //    menuItem: 'Target dan Realisasi Rekening', 
   //    render: () => <Tab.Pane attached={false}><AnggaranRealisasiRekening /></Tab.Pane> 
   // }

]

const IndexRe = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default IndexRe;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report/IndexRe.js